import React, { useEffect, useRef } from 'react';

import confetti from 'canvas-confetti';

const VBW = 337;
const VBH = 579.5;
const MARGIN_X = 160;
const MARGIN_Y = 55;
const FRAME_W = VBW + MARGIN_X * 2;
const FRAME_H = VBH + MARGIN_Y * 2;
const FEET_Y = 575;

const SWIRL_COLORS = ['#fbcf00', '#2f734f'];
const NEW_COLORS = ['#fbcf00', '#2f734f', '#53CC8C', '#FBCB7D', '#67CECD'];
const CONFETTI_COLORS = ['#26ccff', '#a25afd', '#ff5e7e', '#88ff5a', '#fcff42', '#ffa62d', '#ff36ff'];

const BLINK_DURATION = 0.15;
const BLINK_INTERVAL = 2;

const EYES = [{ x: 60.6, y: 153.2 }, { x: 119.2, y: 153.2 }];
const BROW_LEFT = 'M48.1,138s13.1-11.8,25,.3';
const BROW_RIGHT = 'M106.7,138s13.1-11.8,25,.3';
const BROW_L_PIVOT = { x: 80.6, y: 138 };
const BROW_R_PIVOT = { x: 149.2, y: 138 };

const WALK_SPEED = 3.4;
const WALK_SEGMENT_MIN = 3;
const WALK_SEGMENT_MAX = 5;
const PAUSE_SEGMENT = 0.75;
const STRAIGHT_POSE_THRESH = 0.22;
const HIP_SWING = 0.09;
const KNEE_BEND = 0.16;
const FOOT_LIFT = 3;
const SEAM_PAD = 8;
const BREATHE_FREQ = 1.7;
const BREATHE_AMP = 0.006;
const WAG_FREQ = 12;
const WAG_AMP = 0.46;

// ---- hop: triggered by a lot of cursor movement, but rate-limited ----
const JUMP_TRIGGER = 0.85;
const JUMP_COOLDOWN = 1.5;
const JUMP_DUR = 0.55;
const JUMP_HEIGHT = 26;
const JUMP_SQUASH = 0.05;
const JUMP_BEND = 0.2;

const TRICK_GAP_MIN = 1.4;
const TRICK_GAP_MAX = 3;

const EAR_L_PIVOT = { x: 55, y: 102 };
const EAR_R_PIVOT = { x: 150, y: 102 };
const EAR_WIGGLE = 0.06;
const EAR_IDLE = 0.025;
const EAR_FLAP = 0.18;

const PATHS_DATA = [
  { group: 'legFrontFar', t: 'path', d: 'M151.9,456.4c.5-15,.9-10.1-.2-36.7-.5-10.9.2-26.6.9-45.7,41.3-8.6,20.5-68.1,20.1-70-2.5-56-56.9-23.4-61.9,31.7-.5,3.4-2,15.8-2,36.5s11.2,38.9,17.5,70.6c4.1,20.4,1.4,27.2,1.1,46.2s6.2,28.6,3.4,44.7c-1.4,8-12,20.5-12,20.5,0,0,3.7,2.3,7.3,4.2,11.3,3.2,25.9-4.9,25.9-6.9.3-19-3.1-31.7.7-49.2,2.9-13.6-1.5-30.6-.9-46h.1Z', fill: '#b6a999' },
  { group: 'legFrontFar', t: 'path', d: 'M126.2,558.5c-1.2-.6-2.4-1.3-3.4-1.9-.5,1.1-1.4,3.6-1.8,5.1-1.2,4-2.4,9.2,1,10.6,3.2,1.4,6.7,1,13.7-2.2,7.3-3.3,10.7-12.9,11.2-14.6-5.3,2.6-13.6,5-20.6,3h0Z', fill: '#5f4b3c' },
  { group: 'tail', t: 'path', d: 'M296.1,235.9c-22.1,34.8-9.7,38.5,10.8,24.6,1.6-2,15.5-24.7,16.1-37.7.6-13.9-16.7-28.5-16.7-28.5,0,0,.4,20.4-2.4,29.1-1.7,5.3-5.7,10.2-7.8,12.6h0Z', fill: '#937d69' },
  { group: 'legBackFar', t: 'path', d: 'M228.1,405.3s6.2,17.4,15.1,35.1c8.8,17.7,20.5,25.4,21.4,48.6s-9.8,47.5-9.8,47.5h0s2,3.1,16.1,3.6,15.1-2.5,15.1-2.5h0s-2.2-15.8-3.2-37.7c-1-21.8,4.5-31.6,3.6-37.8-.9-6.2-3.9-11.2-13.1-23.5-9.3-12.3-6.9-44.9-6.9-44.9,0,0,5.6-112.4-40.3-57.9-14.3,16.9,2.1,69.5,2.1,69.5h0Z', fill: '#b6a999' },
  { group: 'legBackFar', t: 'path', d: 'M270.8,540.1c-4.8-.2-8.2-.6-10.6-1.2-1.3,2.9-4.6,10.9-5.1,13.1-.7,3.2,6.8,4.7,16.2.3,10.2-4.7,10.2-11.1,10-12.7-2.3.4-5.6.7-10.5.5h0Z', fill: '#5f4b3c' },
  { group: 'body', t: 'path', d: 'M309.6,371.8c10.2-5.5,11.5-11.1,19.7-40.9,8.1-29.8,8.8-44.1-1.4-67.8-10.2-23.7-33.9-29.8-55.6-31.2s-46.6-13.7-64.7-26.6c-9-6.4-51.2-37.4-51.2-37.4-20.9-15.9-39.4-24.4-62.4-15-23,9.4-16.9,53.2,0,90.4l4.1,20.7s4.4,16.1,5.9,30.8c1.7,16.9,3.6,30.8,6.6,42.3s21.8,34.2,37.3,44.6c12.1,8.1,29.1,8.2,32.7,8.2h0l41.1.6c1.8.1,8.8.3,19.3-2.2,5.4-1.3,11.7-3.1,18.8-6.3,3.7-1.7,7.6-3.7,11.7-6.1,2.3-1.3,4.4-2.8,6.4-4.5v-.2s.3-.2.9-.7c-.5.5-.9.7-.9.7,0,0,21.5,6,31.7.5h0Z', fill: '#d5d1cc' },
  { group: 'body', t: 'path', d: 'M332,336c8.1-29.8,6-49.3-4.2-73-10.2-23.7-33.9-29.8-55.6-31.2s-46.6-13.7-64.7-26.6c-9-6.4-26.9-19.4-26.9-19.4,0,0,3.9,8.6-3.9,24.5-10.4,21-26,29.5-30.5,50.6-4,18.7,3.9,28.4,11,42.9,31.1,63.7,70.3,58.5,70.3,58.5,0,0,20-11.8,35.9-24.7-.8,30.9,25.2,28.8,44.4,20.1,16.5-7.5,24.2-21.8,24.2-21.8Z', fill: '#eae6e1' },
  { group: 'legBackNear', t: 'path', d: 'M306.8,546.9c-4.4.3-8.7,0-11.9-.6-.4,13.2,10.2,13.3,13.9,12.8,6-.8,10.2-8.7,10-15.9-2.6,1.5-6.8,3.3-12,3.7Z', fill: '#5f4b3c' },
  { group: 'legBackNear', t: 'path', d: 'M332,336c-7.6,20.5-15,47.1-12.3,64.7s6.8,42.7,4.7,49.5c-2,6.8-6.8,18.3-6.8,30.5s-.2,28.2,3.8,60.1c0,.7-5.8,5.3-14.7,6-8.6.7-17.2-1.1-16.4-3.3,4.5-12.7,6.7-41.2,9.6-54,3.4-14.9.7-23.1-.7-35.9-1.4-12.9-6.1-19-11.5-32.6s-10-34.9-10-34.9c0,0-5.1-10.1-9.7-23.8-57.9-173.8,91.7-101.5,64-26.3Z', fill: '#eae6e1' },
  { group: 'legFrontNear', t: 'path', d: 'M194.1,566.8c-4.5.7-8.7-.4-11.5-1.4,0,.4-.2,1.2-.2,2.4,0,3.6.4,7.4,4.5,10.2,4.3,2.9,9.4,1.2,12.9-1.6,3.8-3,5.1-10.9,5.3-12.9-2.3,1.2-5.6,2.4-11.1,3.3h.1Z', fill: '#5f4b3c' },
  { group: 'legFrontNear', t: 'path', d: 'M182.5,371.9c-1.8,17.3-3.7,35.8-3.6,46.4,0,11.3.7,19.9,1,27.3.1,2.3.1,7.8.6,13.3.5,5.9,4.1,30.8,4.8,36s1.1,9.7-.2,26.5c-1.4,16.8-5.5,42.6-5.5,42.6,0,0,7,4,14.7,2.8,10.2-1.5,13-4.5,15.6-6,.8-.4-1.4-5-2.5-9.8-.9-3.9-.9-7-.7-10.8s.1-18.6-.8-26.3-2-19.5-2.5-34.7c-.1-3.7,6.1-35.2,8.8-47.6,3.2-14.7-.4-61,15.5-69.3,25.6-13.4,86.9-77.3,12.7-102.3-16.5-5.6-51.7,12.9-61.6,32.9-9.3,18.8,5.6,60.9,3.7,78.9h0Z', fill: '#eae6e1' },
  { group: 'head', t: 'path', d: 'M193.6,1.7c1.2-.4,1.8-.6,1.8-.6,0,0-10.8-4.1-31.2,3.6-18.5,7-30.1,15.1-43.1,36.7-12.1,20.1-13.4,41.6-13.5,44.2,3.4-1,9.1-2.4,18-2.9,1.6-.2,3,0,4.3,0v-.2.3c4.6.2,8,1.3,10.7,2.9,0-1.4.3-17.7,6.8-31.7C164.5,17.5,195.4,1.2,195.4,1.2c0,0-.7.2-1.8.5h0Z', fill: '#5f4b3c' },
  { group: 'head', t: 'path', d: 'M120.8,88.7c7.3,0,7.7-6,9-6,.6-4.4,4-26.9,19.1-48.5C166.9,8.7,195.4,1.1,195.4,1.1c0,0-10.8-4.1-31.2,3.6-18.5,7-30.1,15.1-43.1,36.7-12.1,20.1-13.4,41.6-13.5,44.2,3.3,3.2,6,3.2,13.3,3.2h0Z', fill: '#b6a999' },
  { group: 'head', t: 'path', d: 'M139.8.8c.1,0,.2-.1.2-.1,0,0-41.6.9-58.1,30-15.7,27.8-15.6,52.9-15.6,54.9,6.4-3.3,13.1-3.6,19-2.9,0-.4.2-1,.3-1.6,0,.6,0,1.1,0,1.5,3.7.4,7.2,1.3,10,2.3h0c.2-2.9,2-26.5,9.6-45.3C114.3,16.5,140.1.7,140.1.7c0,0-.1,0-.3.2h0Z', fill: '#5f4b3c' },
  { group: 'head', t: 'path', d: 'M85.3,82.7c.9-5.7,5.4-35.1,14.6-50.1C111.4,9.9,139.9.7,139.9.7c0,0-41.6.9-58.1,30-15.7,27.8-15.6,52.9-15.6,54.9,4.9,2.2,10.7,2.4,19-2.9h.1Z', fill: '#b6a999' },
  { group: 'head', t: 'path', d: 'M79.3,243.3c-5.1-.6-11-1.3-13.1.1l12.3,34.2,7.2-20.1,7.7,20.1,12-34.3c-8.9,1.1-26,0-26,0h0Z', fill: '#b6a999' },
  { group: 'head', t: 'path', d: 'M157.3,129.2s.7-9.5-1.4-20.3-8.7-16.2-8.7-16.2c0,0-4.6-11-22-10-17.4.9-22.8,5.4-22.8,5.4,0,0-25.1-14.1-42.5,1.9-1.6,1.4-3,3.1-4.1,5,0,0-3.6,5.7-5.3,11s-2.7,11.1-3,19.7c-1.3,17.1,1.4,34,5.2,44.8,6.8,19.7,7.3,23.3,7.3,23.3,0,0-1.3,11.4-2.7,18.7s-.9,33.8,20.9,36.1c17.4,1.9,31-5,37.9-16,5.7-9,8.3-18.7,8.3-18.7,0,0,19.9-10.4,27.8-31.5,7.3-19.4,6.8-44.9,6.5-52.9-1-.2-1.6-.3-1.6-.3h.2c0,.1,0,0,0,0Z', fill: '#eae6e1' },
  { group: 'head', t: 'path', d: 'M80.1,234.8h-2.1c-11-.6-17.8-6.7-20.5-11.7-.6-.6-.6-4.5-.6-4.8,0-1.3,0-6.4.8-6.7.7-.2,2.5,3.7,3.5,5.6.3.4,3.4,9.7,17.4,10.4,7.2.4,12.7-1.6,16.3-5.7,2.6-3,3.4-6.1,3.4-6.1.4-2,2.4-3.1,4.3-2.7,2,.4,3.1,2.4,2.7,4.3-1.4,6.1-8.4,17.5-25.1,17.5h0Z', fill: '#5f4b3c' },
  { group: 'head', t: 'path', d: 'M79.2,221.4c-10.7,0-14.3-10.7-14.4-11.1-.4-1.4,0-3,1.3-4,1.2-1,2.9-1,4.1-.3.2,0,3.6,2,9.1,2s9-2,9.1-2c1.3-.7,3-.7,4.1.3,1.2,1,1.7,2.6,1.3,4-.4.6-4,11.1-14.7,11.1h0Z', fill: '#5f4b3c' },
  { group: 'earRight', t: 'path', d: 'M210.2,95.3s-.2,0-.4.3c0-.5.1-.7.1-.7l-62.6-2.3c-35.4,0-51.9,37,10.6,36.7.6,1.2.8,1.4.8,0,4.2.4,18.1.7,33.6-6.3,18.7-8.4,17.8-27.8,17.8-27.8h0Z', fill: '#eae6e1' },
  { group: 'earRight', t: 'path', d: 'M150.5,123.2L150.5,123.2L150.4,123.1L150.5,123.2Z', fill: '#b6a999' },
  { group: 'earRight', t: 'path', d: 'M144.9,105l46.6-.7s-14.7,6.3-29.3,6.8c-14.4.4-17.4-6.1-17.4-6.1h0Z', fill: '#b6a999' },
  { group: 'earRight', t: 'path', d: 'M150.5,123.2s18.2,3,37.1-3.7c21.3-7.6,22.7-24.1,22.7-24.1,0,0,.9,19.4-17.8,27.8s-34.9,6.1-34.9,6.1l-7-6.1h-.1Z', fill: '#b6a999' },
  { group: 'earLeft', t: 'path', d: 'M55.9,94.9H0s3,21.4,25.1,26.1c13.4,2.9,19.8,3,22.5,3,32.6,0,23.2-29.1,8.3-29.1Z', fill: '#eae6e1' },
  { group: 'earLeft', t: 'path', d: 'M51.3,103.5l-32.6-.3s11.1,3.4,17.4,4.3c6.3.9,13.4,1.4,13.4,1.4l1.9-5.4h-.1Z', fill: '#b6a999' },
  { group: 'earLeft', t: 'path', d: 'M47.7,123.9c-2.7.2-9.1-.2-22.5-3-8.7-1.9-14.4-6.3-18.1-10.8,3.6,5.8,9.8,12.3,20.8,14.6,10,2.1,16.1,2.7,19.7,2.9,0-1.2,0-2.4.2-3.6h0Z', fill: '#b6a999' },
  { group: 'head', face: true, t: 'circle', cx: 60.6, cy: 153.2, r: 6, stroke: '#5f4b3c', sw: 6 },
  { group: 'head', face: true, t: 'circle', cx: 119.2, cy: 153.2, r: 6, stroke: '#5f4b3c', sw: 6 },
  { group: 'head', face: true, t: 'path', d: BROW_LEFT, stroke: '#5f4b3c', sw: 8, cap: 'round', join: 'round' },
  { group: 'head', face: true, t: 'path', d: BROW_RIGHT, stroke: '#5f4b3c', sw: 8, cap: 'round', join: 'round' },
  { group: 'head', t: 'line', x1: 79.6, y1: 217.4, x2: 79.6, y2: 229.5, stroke: '#5f4b3c', sw: 8, cap: 'round' },
].map((item) => (item.t === 'path' ? { ...item, path2D: new Path2D(item.d) } : item));

const PIVOTS = {
  legFrontFar: { x: 167.9, y: 374 },
  legBackFar: { x: 252.9, y: 384 },
  legBackNear: { x: 317.9, y: 364 },
  legFrontNear: { x: 187.9, y: 369 },
  head: { x: 167.9, y: 234 },
  tail: { x: 297.9, y: 244 },
  body: { x: 217.9, y: 354 },
};

const LEG_CONFIG = {
  legFrontFar: { hip: PIVOTS.legFrontFar, knee: { x: 132.9, y: 479 }, phase: 'A', dir: 'far' },
  legBackFar: { hip: PIVOTS.legBackFar, knee: { x: 265.9, y: 472 }, phase: 'B', dir: 'far' },
  legBackNear: { hip: PIVOTS.legBackNear, knee: { x: 309.9, y: 472 }, phase: 'A', dir: 'near' },
  legFrontNear: { hip: PIVOTS.legFrontNear, knee: { x: 191.9, y: 482 }, phase: 'B', dir: 'near' },
};

const LEG_PARTS = {};
Object.keys(LEG_CONFIG).forEach((name) => {
  LEG_PARTS[name] = PATHS_DATA.filter((it) => it.group === name && it.t === 'path');
});
const FAR_LEGS = Object.keys(LEG_CONFIG).filter((n) => LEG_CONFIG[n].dir === 'far');
const NEAR_LEGS = Object.keys(LEG_CONFIG).filter((n) => LEG_CONFIG[n].dir === 'near');
const LEG_GROUPS = new Set(Object.keys(LEG_CONFIG));

function drawItem(ctx, item) {
  if (item.stroke) {
    ctx.strokeStyle = item.stroke;
    ctx.lineWidth = item.sw;
    ctx.lineCap = item.cap || 'butt';
    ctx.lineJoin = item.join || 'miter';
    if (item.t === 'circle') {
      ctx.beginPath();
      ctx.arc(item.cx, item.cy, item.r, 0, Math.PI * 2);
      ctx.stroke();
    } else if (item.t === 'line') {
      ctx.beginPath();
      ctx.moveTo(item.x1, item.y1);
      ctx.lineTo(item.x2, item.y2);
      ctx.stroke();
    } else {
      ctx.stroke(item.path2D);
    }
  } else if (item.fill) {
    ctx.fillStyle = item.fill;
    ctx.fill(item.path2D);
  }
}

function applyArtTransform(ctx, w, h, bodySway, bodyBob, breathe) {
  const s = Math.min(w / FRAME_W, h / FRAME_H);
  ctx.translate((w - FRAME_W * s) / 2, (h - FRAME_H * s) / 2);
  ctx.scale(s, s);
  ctx.translate(MARGIN_X, MARGIN_Y);
  ctx.translate(bodySway * 40, bodyBob);
  ctx.translate(0, FEET_Y);
  ctx.scale(1, breathe);
  ctx.translate(0, -FEET_Y);
}

function drawLeg(ctx, name, hipAngle, kneeAngle, footLift, w, h, bodySway, bodyBob, breathe) {
  const cfg = LEG_CONFIG[name];
  const parts = LEG_PARTS[name];
  const { hip, knee } = cfg;
  const kneeY = knee.y;
  ctx.save();
  applyArtTransform(ctx, w, h, bodySway, bodyBob, breathe);
  ctx.translate(hip.x, hip.y);
  ctx.rotate(hipAngle);
  ctx.translate(-hip.x, -hip.y);
  ctx.save();
  ctx.translate(knee.x, knee.y - footLift);
  ctx.rotate(kneeAngle);
  ctx.translate(-knee.x, -knee.y);
  ctx.beginPath();
  ctx.rect(60, kneeY - SEAM_PAD, 320, 700);
  ctx.clip();
  parts.forEach((p) => drawItem(ctx, p));
  ctx.restore();
  ctx.save();
  ctx.beginPath();
  ctx.rect(60, 0, 320, kneeY + SEAM_PAD);
  ctx.clip();
  parts.forEach((p) => drawItem(ctx, p));
  ctx.restore();
  ctx.restore();
}

function drawClosedEyelids(ctx, w, h, bodySway, bodyBob, breathe, headRotation, hsx, hsy) {
  ctx.save();
  applyArtTransform(ctx, w, h, bodySway, bodyBob, breathe);
  const hp = PIVOTS.head;
  ctx.translate(hp.x, hp.y);
  ctx.rotate(headRotation);
  ctx.translate(hsx, hsy);
  ctx.translate(-hp.x, -hp.y);
  ctx.strokeStyle = '#5f4b3c';
  ctx.lineWidth = 6;
  ctx.lineCap = 'round';
  EYES.forEach((e) => {
    ctx.beginPath();
    ctx.moveTo(e.x - 8, e.y + 2);
    ctx.lineTo(e.x + 8, e.y + 2);
    ctx.stroke();
  });
  ctx.restore();
}

function updateBlinkState(t, b) {
  let blinking = false;
  const second = b.dbl ? 0.12 + BLINK_DURATION : 0;
  if (t >= b.next && t <= b.next + BLINK_DURATION) blinking = true;
  else if (b.dbl && t >= b.next + BLINK_DURATION + 0.12 && t <= b.next + 2 * BLINK_DURATION + 0.12) blinking = true;
  else if (t > b.next + BLINK_DURATION + second) {
    b.next = t + BLINK_INTERVAL + Math.random() * 2;
    b.dbl = Math.random() < 0.3;
  }
  return blinking;
}

function drawGroupedItem(ctx, item, w, h, bodySway, bodyBob, breathe, rotations, hsx, hsy, faceScale, smileScale) {
  ctx.save();
  applyArtTransform(ctx, w, h, bodySway, bodyBob, breathe);
  const p = PIVOTS[item.group] || { x: 0, y: 0 };
  ctx.translate(p.x, p.y);
  ctx.rotate(rotations[item.group] || 0);
  if (item.group === 'head') ctx.translate(hsx, hsy);
  ctx.translate(-p.x, -p.y);
  if (item.face && item.t === 'circle' && faceScale && faceScale !== 1) {
    ctx.translate(item.cx, item.cy);
    ctx.scale(faceScale, faceScale);
    ctx.translate(-item.cx, -item.cy);
  }
  if (item.smile && smileScale && smileScale !== 1) {
    ctx.translate(79.2, 216);
    ctx.scale(smileScale, smileScale);
    ctx.translate(-79.2, -216);
  }
  drawItem(ctx, item);
  ctx.restore();
}

function isBrow(item) {
  return item.d === BROW_LEFT || item.d === BROW_RIGHT;
}

function drawBrowItem(ctx, item, w, h, bodySway, bodyBob, breathe, headRotation, hsx, hsy, raise, tilt, pivot, scale) {
  ctx.save();
  applyArtTransform(ctx, w, h, bodySway, bodyBob, breathe);
  const hp = PIVOTS.head;
  ctx.translate(hp.x, hp.y);
  ctx.rotate(headRotation);
  ctx.translate(hsx, hsy);
  ctx.translate(-hp.x, -hp.y);
  ctx.translate(pivot.x, pivot.y);
  ctx.rotate(tilt);
  if (scale && scale !== 1) ctx.scale(scale, scale);
  ctx.translate(-pivot.x, -pivot.y);
  ctx.translate(0, -raise);
  drawItem(ctx, item);
  ctx.restore();
}

function drawEarItem(ctx, item, w, h, bodySway, bodyBob, breathe, headRotation, hsx, hsy, earAngle, pivot) {
  ctx.save();
  applyArtTransform(ctx, w, h, bodySway, bodyBob, breathe);
  const hp = PIVOTS.head;
  ctx.translate(hp.x, hp.y);
  ctx.rotate(headRotation);
  ctx.translate(hsx, hsy);
  ctx.translate(-hp.x, -hp.y);
  ctx.translate(pivot.x, pivot.y);
  ctx.rotate(earAngle);
  ctx.translate(-pivot.x, -pivot.y);
  drawItem(ctx, item);
  ctx.restore();
}

function isStraightLegPose(walkTime) {
  return Math.abs(Math.cos(walkTime * WALK_SPEED)) < STRAIGHT_POSE_THRESH;
}

function snapWalkTimeToStraightPose(walkTime) {
  const cycle = walkTime * WALK_SPEED;
  const straightCycle = (Math.round((cycle - Math.PI / 2) / Math.PI)) * Math.PI + Math.PI / 2;
  return straightCycle / WALK_SPEED;
}

function renderFrame(ctx, w, h, time, mouseX, mouseY, animateWalk, blinkState, tailWag, introNod, energy, jumpOffset, jumpStretch, jumpBend, headState, extras = {}, walkTime) {
  ctx.clearRect(0, 0, w, h);
  const cycle = (walkTime != null ? walkTime : time) * (animateWalk ? WALK_SPEED : 0);
  const swing = {
    A: Math.sin(cycle) * (animateWalk ? HIP_SWING : 0),
    B: Math.sin(cycle + Math.PI) * (animateWalk ? HIP_SWING : 0),
  };
  const bend = {
    A: animateWalk ? KNEE_BEND * Math.max(0, Math.cos(cycle)) : 0,
    B: animateWalk ? KNEE_BEND * Math.max(0, Math.cos(cycle + Math.PI)) : 0,
  };
  const lift = {
    A: animateWalk ? FOOT_LIFT * Math.max(0, Math.cos(cycle)) : 0,
    B: animateWalk ? FOOT_LIFT * Math.max(0, Math.cos(cycle + Math.PI)) : 0,
  };
  const pr = extras.prance || 0;
  if (pr) {
    lift.A *= 1 + pr * 1.9;
    lift.B *= 1 + pr * 1.9;
    bend.A *= 1 + pr * 1.3;
    bend.B *= 1 + pr * 1.3;
  }
  const bodyBob = (animateWalk ? Math.pow(Math.abs(Math.sin(cycle)), 0.7) * 6 : 0) + (jumpOffset || 0) + pr * 4;
  const bodySway = animateWalk ? Math.sin(cycle) * 0.02 : 0;
  const breathe = (animateWalk ? 1 + Math.sin(time * BREATHE_FREQ) * BREATHE_AMP : 1) * (jumpStretch || 1);

  const dx = mouseX - w / 2;
  const dy = mouseY - h / 2;
  const idleBlend = Math.min(1, Math.max(0, (headState.stillTime - 0.7) / 1.0));
  const trackHX = Math.max(-0.25, Math.min(0.25, dx * 0.0006));
  const trackHY = Math.max(-5, Math.min(5, dy * 0.015));
  const idleNod = idleBlend * Math.sin(time * 4) * 3;
  const idleRot = idleBlend * Math.sin(time * 4) * 0.03;
  const targetHX = trackHX * (1 - idleBlend);
  const targetHY = trackHY * (1 - idleBlend) + idleNod;

  const stiffness = 0.14;
  const damping = 0.72;
  const curl = 0.01;
  headState.headVelX += (targetHX - headState.headX) * stiffness;
  headState.headVelX *= damping;
  headState.headVelY += (targetHY - headState.headY) * stiffness;
  headState.headVelY *= damping;
  headState.headVelX += headState.headVelY * curl;
  headState.headVelY -= headState.headVelX * curl;
  headState.headX += headState.headVelX;
  headState.headY += headState.headVelY;

  const headAngle = headState.headX;
  const hsx = headAngle * 10 * Math.sin(time * 2);
  const nodAmount = (introNod || 0) * Math.sin(time * 7) * 6;
  const nodRot = (introNod || 0) * Math.sin(time * 5) * 0.10 + idleRot;
  const hsy = headState.headY + nodAmount * Math.sin(time * 2) + (extras.headPerkY || 0);
  const headRotation = (animateWalk ? Math.sin(cycle) * 0.015 : 0) + headAngle + nodRot + (extras.headTilt || 0);
  const browUp = Math.max(0, Math.min(5, -dy * 0.016));
  const curious = animateWalk ? Math.sin(time * 0.7) * 2 : 0;
  const browLRaise = browUp + Math.max(-4.5, Math.min(6, -dx * 0.014)) + curious + (extras.browBoost || 0);
  const browRRaise = browUp + Math.max(-4.5, Math.min(6, dx * 0.014)) + curious + (extras.browBoost || 0);
  const browLTilt = Math.max(-0.08, Math.min(0.08, dx * 0.001));
  const browRTilt = Math.max(-0.08, Math.min(0.08, -dx * 0.001));
  const nx = Math.min(1, Math.abs(dx) / (w / 2));
  const ny = Math.min(1, Math.abs(dy) / (h / 2));
  const faceScale = 1 + nx * ny * 0.08 + (extras.faceBoost || 0);
  const smileScale = 1 + (energy || 0) * 0.15;
  const rotations = {
    tail: (animateWalk ? Math.sin(cycle * 3) * 0.05 : 0)
      + (animateWalk ? Math.sin(time * 1.6) * 0.03 : 0)
      + (tailWag || 0)
      + (extras.tailExtra || 0),
    head: headRotation,
    body: (animateWalk ? Math.sin(cycle) * 0.01 : 0) + (extras.bodyWiggle || 0),
  };

  const blinking = animateWalk ? updateBlinkState(time, blinkState) : false;
  const earFlap = (-(jumpOffset || 0) / JUMP_HEIGHT) * EAR_FLAP;
  const earAngleL = (animateWalk
    ? Math.sin(cycle * 2) * EAR_WIGGLE + Math.sin(time * 1.3) * EAR_IDLE + earFlap
    : 0) + (extras.earL || 0);
  const earAngleR = (animateWalk
    ? Math.sin(cycle * 2 + 0.8) * EAR_WIGGLE + Math.sin(time * 1.3 + 0.6) * EAR_IDLE - earFlap
    : 0) + (extras.earR || 0);
  const legArgs = (name) => {
    const ph = LEG_CONFIG[name].phase;
    return [swing[ph], bend[ph], lift[ph]];
  };

  FAR_LEGS.forEach((name) => {
    const [s, b, l] = legArgs(name);
    drawLeg(ctx, name, s, b + (jumpBend || 0), l, w, h, bodySway, bodyBob, breathe);
  });
  for (const item of PATHS_DATA) {
    if (LEG_GROUPS.has(item.group)) continue;
    if (blinking && item.face && item.t === 'circle') continue;
    if (item.group === 'earLeft' || item.group === 'earRight') {
      const isL = item.group === 'earLeft';
      drawEarItem(
        ctx, item, w, h, bodySway, bodyBob, breathe, headRotation, hsx, hsy,
        isL ? earAngleL : earAngleR,
        isL ? EAR_L_PIVOT : EAR_R_PIVOT,
      );
      continue;
    }
    if (isBrow(item)) {
      const isLeft = item.d === BROW_LEFT;
      drawBrowItem(
        ctx, item, w, h, bodySway, bodyBob, breathe, headRotation, hsx, hsy,
        isLeft ? browLRaise : browRRaise,
        isLeft ? browLTilt : browRTilt,
        isLeft ? BROW_L_PIVOT : BROW_R_PIVOT,
        faceScale,
      );
      continue;
    }
    drawGroupedItem(ctx, item, w, h, bodySway, bodyBob, breathe, rotations, hsx, hsy, faceScale, smileScale);
  }
  if (blinking) drawClosedEyelids(ctx, w, h, bodySway, bodyBob, breathe, headRotation, hsx, hsy);
  NEAR_LEGS.forEach((name) => {
    const [s, b, l] = legArgs(name);
    drawLeg(ctx, name, s, b + (jumpBend || 0), l, w, h, bodySway, bodyBob, breathe);
  });
}

/**
 * Full-body walking goat (from willygoat-walk-6.html).
 * Cursor-aware head/brow tracking, ear wiggle, blinking, hops, tricks, and tail wag.
 */
export const GoatAnimationCanvas = ({ celebrate = false }) => {
  const canvasRef = useRef(null);
  const celebrateRef = useRef(false);

  useEffect(() => {
    if (celebrate) celebrateRef.current = true;
  }, [celebrate]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ctx = canvas.getContext('2d');
    if (!ctx) return undefined;

    let rafId = 0;
    let disposed = false;
    let time = 0;
    let lastTs = 0;
    let mouseX = 0;
    let mouseY = 0;
    let pmx = 0;
    let pmy = 0;
    let wagE = 0;
    let clickPulse = 0;
    const blinkState = { next: Math.random() * 5 + 5, dbl: false };
    let introNod = 1;
    let introStarted = false;
    // --- click confetti: little spinning swirls in the WillyGoat palette ---
    // const SWIRL_COLORS = ['#f2c14e', '#fbcf00', '#6fb3e0', '#c98bdb', '#2f734f'];
    
    const swirls = [];

    let moveAccum = 0;
    let jumpCooldown = 0;
    let jumping = false;
    let jumpClock = 0;
    let trickNext = 1.2 + Math.random() * 2;
    let trickActive = false;
    let trickName = '';
    let trickClock = 0;
    let trickDur = 1;
    let trickDir = 1;
    let lastTrick = '';
    let pendingHops = 0;
    let walkCycleTime = 0;
    let walkSegmentTimer = 0;
    let pauseTimer = 0;
    let walkMode = 'walk';
    let walkSegmentTarget = WALK_SEGMENT_MIN + Math.random() * (WALK_SEGMENT_MAX - WALK_SEGMENT_MIN);
    const headState = { headVelX: 0, headVelY: 0, headX: 0, headY: 0, stillTime: 0 };

    const pointerToCanvas = (clientX, clientY) => {
      const rect = canvas.getBoundingClientRect();
      return {
        x: (clientX - rect.left) * (canvas.width / rect.width),
        y: (clientY - rect.top) * (canvas.height / rect.height),
      };
    };

    const resize = () => {
      const rect = canvas.getBoundingClientRect();
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(rect.width * dpr);
      canvas.height = Math.round(rect.height * dpr);
      mouseX = canvas.width / 2;
      mouseY = canvas.height / 2;
    };

    resize();

    const onPointerMove = (e) => {
      const p = pointerToCanvas(e.clientX, e.clientY);
      mouseX = p.x;
      mouseY = p.y;
    };
    const onPointerDown = () => { 
      clickPulse = 1; 
      // spawnSwirls(mouseX, mouseY);

      confetti({
        particleCount: 100,
        spread: 70,
        origin: { x: 0.5, y: 0.5 },
        // colors: CONFETTI_COLORS,
        colors: NEW_COLORS,
      });
    };
    const onResize = () => resize();
    const onVisibility = () => {
      if (!document.hidden) {
        lastTs = 0;
        rafId = requestAnimationFrame(animate);
      }
    };

    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('resize', onResize);
    document.addEventListener('visibilitychange', onVisibility);

    function spawnSwirls(x, y) {
      if (reducedMotion) return;
      const scale = (canvas.height / 660) || 1;
      const n = 6 + (Math.random() * 5 | 0);                 // 6-10 swirls per click
      for (let i = 0; i < n; i++) {
        const ang = Math.random() * Math.PI * 2;
        const spd = (70 + Math.random() * 150) * scale;
        swirls.push({
          x, y,
          vx: Math.cos(ang) * spd,
          vy: Math.sin(ang) * spd - 50 * scale,              // slight upward bias, like confetti
          age: 0,
          life: 0.7 + Math.random() * 0.5,
          size: (9 + Math.random() * 11) * scale,
          rot: Math.random() * Math.PI * 2,
          spin: (Math.random() < 0.5 ? -1 : 1) * (3 + Math.random() * 4),
          curl: (Math.random() < 0.5 ? -1 : 1) * (1.5 + Math.random() * 2.2),
          color: SWIRL_COLORS[(Math.random() * SWIRL_COLORS.length) | 0],
        });
      }
      if (swirls.length > 140) swirls.splice(0, swirls.length - 140);
    }
  
    function drawSwirl(s) {
      const p = s.age / s.life;
      const alpha = Math.min(1, s.age / 0.1) * (1 - p);      // quick pop-in, then fade
      if (alpha <= 0) return;
      const R = s.size * (0.45 + p * 0.95);                  // grows as it travels
      ctx.save();
      ctx.translate(s.x, s.y);
      ctx.rotate(s.rot);
      ctx.globalAlpha = alpha;
      ctx.strokeStyle = s.color;
      ctx.lineWidth = Math.max(1.5, 2.4 * ((canvas.height / 700) || 1));
      ctx.beginPath();
      const STEPS = 26, maxT = 1.4 * Math.PI * 2;            // ~1.4 turns of an Archimedean spiral
      for (let k = 0; k <= STEPS; k++) {
        const t = (k / STEPS) * maxT;
        const rr = (R / maxT) * t;
        const px = Math.cos(t) * rr, py = Math.sin(t) * rr;
        if (k === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
      }
      ctx.stroke();
      ctx.restore();
    }
  
    function updateAndDrawSwirls(dt) {
      if (!swirls.length) return;
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);                    // screen space, on top of the goat
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      for (let i = swirls.length - 1; i >= 0; i--) {
        const s = swirls[i];
        s.age += dt;
        if (s.age >= s.life) { swirls.splice(i, 1); continue; }
        s.vx *= 0.96; s.vy *= 0.96;                          // drag
        const cc = Math.cos(s.curl * dt), sc = Math.sin(s.curl * dt);
        const nvx = s.vx * cc - s.vy * sc;                   // curl the path so it spirals out
        s.vy = s.vx * sc + s.vy * cc; s.vx = nvx;
        s.x += s.vx * dt; s.y += s.vy * dt;
        s.rot += s.spin * dt;
        drawSwirl(s);
      }
      ctx.restore();
    }


    const animate = (ts) => {
      if (disposed) return;

      const dt = lastTs ? Math.min((ts - lastTs) / 1000, 0.05) : 0;
      if (!reducedMotion) { time += dt; lastTs = ts; }

      if (!introStarted) { pmx = mouseX; pmy = mouseY; introStarted = true; }
      const moved = Math.hypot(mouseX - pmx, mouseY - pmy); pmx = mouseX; pmy = mouseY;
      if (moved > 3) { introNod = 0; headState.stillTime = 0; }
      else { headState.stillTime += dt; }
      introNod = Math.max(0, introNod - 0.008);
      const target = moved > 0.8 ? 1 : 0;

      wagE += (target - wagE) * (target > wagE ? 0.35 : 0.05);
      clickPulse *= 0.92;
      const energy = Math.min(1, Math.max(wagE, clickPulse));
      const tailWag = reducedMotion ? 0 : Math.sin(time * WAG_FREQ) * WAG_AMP * energy;

      if (!reducedMotion) {
        if (walkMode === 'walk') {
          walkCycleTime += dt;
          walkSegmentTimer += dt;
          if (walkSegmentTimer >= walkSegmentTarget && isStraightLegPose(walkCycleTime)) {
            walkCycleTime = snapWalkTimeToStraightPose(walkCycleTime);
            walkMode = 'pause';
            pauseTimer = 0;
          }
        } else {
          pauseTimer += dt;
          if (pauseTimer >= PAUSE_SEGMENT) {
            walkMode = 'walk';
            walkSegmentTimer = 0;
            walkSegmentTarget = WALK_SEGMENT_MIN + Math.random() * (WALK_SEGMENT_MAX - WALK_SEGMENT_MIN);
          }
        }
      }
      const isPaused = !reducedMotion && walkMode === 'pause';
      const isWalking = !reducedMotion && walkMode === 'walk';

      // --- celebration hop (quote submitted) ---
      if (!reducedMotion && celebrateRef.current && !jumping) {
        celebrateRef.current = false;
        jumping = true;
        jumpClock = 0;
        jumpCooldown = JUMP_COOLDOWN;
        pendingHops = 1;
        clickPulse = 1;
        
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { x: 0.5, y: 0.6 }
        });
        // spawnSwirls(canvas.width / 2, canvas.height * 0.45);
      }

      // --- occasional hop: builds up with a lot of cursor movement, then rate-limited ---
      const movedFrac = canvas.width ? moved / canvas.width : 0;
      moveAccum = moveAccum * 0.82 + movedFrac;
      jumpCooldown = Math.max(0, jumpCooldown - dt);
      if (!reducedMotion && !jumping && jumpCooldown === 0 && moveAccum > JUMP_TRIGGER) {
        jumping = true;
        jumpClock = 0;
        jumpCooldown = JUMP_COOLDOWN;
        moveAccum = 0;
      }
      let jumpOffset = 0;
      let jumpStretch = 1;
      let jumpBend = 0;
      if (jumping) {
        jumpClock += dt;
        const p = jumpClock / JUMP_DUR;
        if (p >= 1) {
          jumping = false;
          if (pendingHops > 0) { pendingHops -= 1; jumping = true; jumpClock = 0; }
        } else {
          jumpOffset = -Math.sin(p * Math.PI) * JUMP_HEIGHT;
          jumpStretch = 1 + Math.cos(p * Math.PI) * JUMP_SQUASH;
          jumpBend = Math.sin(p * Math.PI) * JUMP_BEND;
        }
      }

      const extras = {
        bodyWiggle: 0,
        headTilt: 0,
        headPerkY: 0,
        browBoost: 0,
        faceBoost: 0,
        tailExtra: 0,
        prance: 0,
        earL: 0,
        earR: 0,
      };
      if (!reducedMotion) {
        if (!trickActive && !jumping && isWalking && time > trickNext) {
          const tricks = ['hop', 'bounce', 'prance', 'perk', 'headTilt', 'lookAround', 'headShake', 'wiggle', 'tailFlurry', 'earFlick', 'graze'];
          do { trickName = tricks[(Math.random() * tricks.length) | 0]; } while (trickName === lastTrick);
          lastTrick = trickName;
          trickDir = Math.random() < 0.5 ? -1 : 1;
          trickClock = 0;
          trickDur = {
            hop: 0.6, bounce: 1.25, prance: 1.5, perk: 1.1, headTilt: 1.3,
            lookAround: 1.9, headShake: 0.8, wiggle: 0.95, tailFlurry: 1.2, earFlick: 0.6, graze: 1.7,
          }[trickName];
          trickActive = true;
          if (trickName === 'hop' || trickName === 'bounce') {
            jumping = true;
            jumpClock = 0;
            jumpCooldown = JUMP_COOLDOWN;
            pendingHops = trickName === 'bounce' ? 1 : 0;
          }
        }
        if (trickActive) {
          trickClock += dt;
          if (trickClock >= trickDur) {
            trickActive = false;
            trickNext = time + TRICK_GAP_MIN + Math.random() * (TRICK_GAP_MAX - TRICK_GAP_MIN);
          } else {
            const p = trickClock / trickDur;
            const env = Math.sin(Math.PI * p);
            const c = trickClock;
            if (trickName === 'prance') {
              extras.prance = env;
              extras.headPerkY = -env * 2;
              extras.browBoost = env * 1.5;
              extras.earL = -env * 0.05;
              extras.earR = env * 0.05;
            } else if (trickName === 'perk') {
              extras.headPerkY = -env * 7;
              extras.browBoost = env * 5;
              extras.faceBoost = env * 0.07;
              extras.earL = -env * 0.22;
              extras.earR = env * 0.22;
              extras.tailExtra = env * Math.sin(c * 16) * 0.25;
            } else if (trickName === 'headTilt') {
              extras.headTilt = env * 0.16 * trickDir;
              extras.browBoost = env * 2;
              extras.earL = env * 0.08 * trickDir;
              extras.earR = env * 0.08 * trickDir;
            } else if (trickName === 'lookAround') {
              extras.headTilt = Math.sin(p * Math.PI * 2) * 0.17;
              extras.headPerkY = -env * 3;
              extras.browBoost = env * 2;
            } else if (trickName === 'headShake') {
              extras.headTilt = env * Math.sin(c * 2) * 0.11;
              extras.earL = env * Math.sin(c * 32) * 0.15;
              extras.earR = env * Math.sin(c * 32) * 0.15;
            } else if (trickName === 'wiggle') {
              const wv = env * Math.sin(c * 20);
              extras.bodyWiggle = wv * 0.05;
              extras.headTilt = -wv * 0.03;
              extras.tailExtra = wv * 0.25;
              extras.earL = wv * 0.14;
              extras.earR = -wv * 0.14;
            } else if (trickName === 'tailFlurry') {
              extras.tailExtra = env * Math.sin(c * 26) * 0.6;
              extras.faceBoost = env * 0.04;
            } else if (trickName === 'earFlick') {
              const flick = env * Math.sin(c * 38) * 0.4;
              if (trickDir > 0) extras.earR = flick;
              else extras.earL = flick;
            } else if (trickName === 'graze') {
              const down = Math.sin(p * Math.PI);
              extras.headPerkY = down * 13 + down * Math.sin(c * 22) * 2;
              extras.headTilt = down * 0.05;
              extras.earL = down * 0.1;
              extras.earR = -down * 0.1;
            }
          }
        }
      }

      const animateWalk = isWalking || isPaused;
      renderFrame(
        ctx,
        canvas.width,
        canvas.height,
        time,
        mouseX,
        mouseY,
        animateWalk,
        blinkState,
        tailWag,
        introNod,
        energy,
        jumpOffset,
        jumpStretch,
        jumpBend,
        headState,
        extras,
        walkCycleTime,
      );
      // updateAndDrawSwirls(dt);
      rafId = requestAnimationFrame(animate);
    };

    if (reducedMotion) {
      renderFrame(ctx, canvas.width, canvas.height, 0, mouseX, mouseY, false, blinkState, 0, 0, 0, 0, 1, 0, headState);
    } else {
      rafId = requestAnimationFrame(animate);
    }

    return () => {
      disposed = true;
      cancelAnimationFrame(rafId);
      window.removeEventListener('pointermove', onPointerMove);
      window.removeEventListener('pointerdown', onPointerDown);
      window.removeEventListener('resize', onResize);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      id="goat-canvas-walk-6"
      className="goat-canvas"
      width={FRAME_W}
      height={FRAME_H}
      aria-label="Animated WillyGoat walking"
      style={{
        width: 'min(100%, 500px)',
        maxWidth: 460,
        aspectRatio: `${FRAME_W} / ${FRAME_H}`,
        display: 'block',
      }}
    />
  );
};

export default GoatAnimationCanvas;
